import { render, staticRenderFns } from "./DispositivosContatoBeneficiario.vue?vue&type=template&id=08e0cfc4"
import script from "./DispositivosContatoBeneficiario.vue?vue&type=script&lang=js"
export * from "./DispositivosContatoBeneficiario.vue?vue&type=script&lang=js"
import style0 from "./DispositivosContatoBeneficiario.vue?vue&type=style&index=0&id=08e0cfc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports